var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserAltOrange = function SvgUserAltOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M45.5 22C45.5 24.67 44.7082 27.2801 43.2248 29.5002C41.7414 31.7203 39.633 33.4506 37.1662 34.4724C34.6994 35.4942 31.985 35.7615 29.3663 35.2406C26.7475 34.7197 24.3421 33.434 22.4541 31.5459C20.5661 29.6579 19.2803 27.2525 18.7594 24.6337C18.2385 22.015 18.5058 19.3006 19.5276 16.8338C20.5494 14.367 22.2797 12.2586 24.4998 10.7752C26.7199 9.29176 29.33 8.5 32 8.5C35.5804 8.5 39.0142 9.92232 41.5459 12.4541C44.0777 14.9858 45.5 18.4196 45.5 22Z",
    fill: "#FF7342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44 38.5H38.8344C36.6915 39.4881 34.3598 39.9998 32 39.9998C29.6402 39.9998 27.3085 39.4881 25.1656 38.5H20C16.8174 38.5 13.7652 39.7643 11.5147 42.0147C9.26428 44.2652 8 47.3174 8 50.5L8 52C8 53.1935 8.47411 54.3381 9.31802 55.182C10.1619 56.0259 11.3065 56.5 12.5 56.5H51.5C52.6935 56.5 53.8381 56.0259 54.682 55.182C55.5259 54.3381 56 53.1935 56 52V50.5C56 47.3174 54.7357 44.2652 52.4853 42.0147C50.2348 39.7643 47.1826 38.5 44 38.5Z",
    fill: "#FF7342"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserAltOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-alt-orange.e032a924.svg";
export { ForwardRef as ReactComponent };